import PropTypes from 'prop-types';
import React from 'react';
import { Provider as CompanyContextProvider } from '../../../../contexts/CompanyContext';
import { Consumer as PageConsumer } from '../../../../contexts/PageContext';
import {
    COMPANY_PROPTYPES,
    DEFAULT_COMPANY_PROPS,
} from '../../../Includes/CompanyProps';
import CompanyHeaderV2 from '../../CompanyHeaderV2/CompanyHeaderV2';
import './CompanyHeaderSticky.scss';

export default class CompanyHeaderSticky extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            showSticky: false,
        };
    }

    static propTypes = {
        children: PropTypes.node.isRequired,
        company: PropTypes.shape(COMPANY_PROPTYPES),
        userId: PropTypes.number,
    };

    static defaultProps = {
        company: DEFAULT_COMPANY_PROPS,
    };

    componentDidMount() {
        this.showTopSticky();
        window.addEventListener('scroll', this.showTopSticky);
        window.addEventListener('resize', this.showTopSticky);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.showTopSticky);
        window.removeEventListener('resize', this.showTopSticky);
    }

    setStickyRef = (node) => {
        this.stickyRef = node;
    };

    showTopSticky = () => {
        if (!this.stickyRef || !this.stickyRef.getBoundingClientRect) {
            return;
        }
        let stickyRef = this.stickyRef.getBoundingClientRect();
        const MIN_IPHONE_HEIGHT = 568;
        if (stickyRef.top <= 0 && stickyRef.bottom >= -MIN_IPHONE_HEIGHT) {
            if (!this.state.showSticky) {
                this.setState({ showSticky: true });
            }
        } else if (this.state.showSticky) {
            this.setState({ showSticky: false });
        }
    };

    render() {
        return (
            <div className="component-Layout-StickyTopBar-CompanyHeaderSticky">
                <CompanyContextProvider
                    company={this.props.company}
                    userId={this.props.userId}
                >
                    <PageConsumer>
                        {(context) => {
                            return (
                                <React.Fragment>
                                    <CompanyHeaderV2
                                        isSticky={this.state.showSticky}
                                        context={context}
                                        shouldSubNavOpenNewTabs={
                                            this.props.shouldSubNavOpenNewTabs
                                        }
                                    />
                                    <div ref={this.setStickyRef}>
                                        {this.props.children}
                                    </div>
                                </React.Fragment>
                            );
                        }}
                    </PageConsumer>
                </CompanyContextProvider>
            </div>
        );
    }
}
